import { useCallback, useState } from 'react';

import Button from '@mui/material/Button';
import UploadImagesBox from '../../components/upload-images-box';
import ImageUploadGallery from '../image-upload-gallery';
import MaterialLinkButton from '../material-link-button';
import SectionHeader from '../section-header';
import type { Group } from '../../types/Group';

type Props = {
  group: Group;
  imageUploadsCount?: number;
  slug?: string;
};

const GroupImageUploads = ({ group, imageUploadsCount, slug }: Props) => {
  const [uploadOpen, setUploadOpen] = useState(false);

  const handleToggleUploadOpen = useCallback(() => {
    setUploadOpen(!uploadOpen);
  }, [uploadOpen]);

  if (!group.permissions.accessible) {
    return null;
  }

  return (
    <div style={{ marginBottom: 24 }}>
      <SectionHeader>Photos</SectionHeader>

      <ImageUploadGallery
        imageUploads={group.imageUploads}
        galleryId={group.id}
      />

      {imageUploadsCount != null && slug && imageUploadsCount !== group.imageUploads?.length && (
        <MaterialLinkButton
          href={`/groups/${slug}/photos`}
          variant="outlined"
          sx={{ mt: 1 }}
        >
          View Full Gallery
        </MaterialLinkButton>
      )}

      {uploadOpen ? (
        <UploadImagesBox
          group={group}
          onClose={handleToggleUploadOpen}
        />
      ) : (
        group.permissions.uploadImage && (
          <Button
            onClick={handleToggleUploadOpen}
            variant="contained"
            color="primary"
            sx={{ mt: 1 }}
          >
            Upload Photos
          </Button>
        )
      )}
    </div>
  );
};

export default GroupImageUploads;
